import { useEffect } from 'react';

type SchemaType = 'Organization' | 'WebSite' | 'WebPage' | 'BreadcrumbList' | 'Article' | 'FAQPage';

interface SeoProps {
  type: SchemaType;
  data: any;
}

function buildJsonLd(type: SchemaType, data: any): object {
  const base = { '@context': 'https://schema.org' };

  switch (type) {
    case 'Organization':
      return {
        ...base,
        '@type': 'Organization',
        name: data.name || '土豪漫画网',
        url: data.url || 'http://thinkbu.com/',
        description: data.description || '免费漫画下拉式浏览平台，提供高清韩漫人气榜和韩国漫画在线观看服务',
        sameAs: data.sameAs || [],
      };
    case 'WebSite':
      return {
        ...base,
        '@type': 'WebSite',
        name: data.name || '土豪漫画网',
        url: data.url || 'http://thinkbu.com/',
        description: data.description || '免费漫画下拉式浏览平台，提供高清韩漫人气榜和韩国漫画在线观看服务',
        potentialAction: {
          '@type': 'SearchAction',
          target: 'http://thinkbu.com/search?q={search_term_string}',
          'query-input': 'required name=search_term_string',
        },
      };
    case 'WebPage':
      return {
        ...base,
        '@type': 'WebPage',
        name: data.name || '土豪漫画网',
        url: data.url || 'http://thinkbu.com/',
        description: data.description || '免费漫画下拉式浏览平台，提供高清韩漫人气榜和韩国漫画在线观看服务',
      };
    case 'BreadcrumbList':
      return {
        ...base,
        '@type': 'BreadcrumbList',
        itemListElement: (data.items || []).map((item: any, idx: number) => ({
          '@type': 'ListItem',
          position: idx + 1,
          name: item.name,
          item: item.url,
        })),
      };
    case 'Article':
      return {
        ...base,
        '@type': 'Article',
        headline: data.headline || '',
        url: data.url || '',
        description: data.description || '',
        author: {
          '@type': 'Organization',
          name: data.author || '土豪漫画网',
        },
        publisher: {
          '@type': 'Organization',
          name: '土豪漫画网',
          url: 'http://thinkbu.com/',
        },
        datePublished: data.publishDate || '2024-01-01',
        dateModified: data.publishDate || '2024-01-01',
        image: data.image || '',
      };
    case 'FAQPage':
      return {
        ...base,
        '@type': 'FAQPage',
        mainEntity: (data.questions || []).map((q: any) => ({
          '@type': 'Question',
          name: q.question,
          acceptedAnswer: {
            '@type': 'Answer',
            text: q.answer,
          },
        })),
      };
    default:
      return { ...base, '@type': type };
  }
}

export default function SeoStructuredData({ type, data }: SeoProps) {
  const jsonLd = buildJsonLd(type, data);
  const id = `jsonld-${type.toLowerCase()}`;

  useEffect(() => {
    let el = document.getElementById(id);
    if (!el) {
      el = document.createElement('script');
      el.id = id;
      el.type = 'application/ld+json';
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(jsonLd);
    return () => {
      const cleanupEl = document.getElementById(id);
      if (cleanupEl) cleanupEl.remove();
    };
  }, [id, jsonLd]);

  return null;
}